<h1>Add Users</h1>
<div id="add-users">
    <div *ngIf="error">{{error}}</div>
    <div fxLayout="column">
        <div fxLayout="row" fxLayoutGap="10px">
            <!-- username -->
            <mat-form-field fxFlex="50">
                <input 
                    matInput 
                    name="username"
                    [formControl]="control"  
                    placeholder="Username" 
                    [matAutocomplete]="auto">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="setUser($event)">
                    <mat-option *ngFor="let option of options" [value]="option">
                        {{ option.username }}
                    </mat-option>
                    </mat-autocomplete>
            </mat-form-field>

            <!-- role -->
            <mat-form-field fxFlex="50">
                <mat-select placeholder="Role" [(ngModel)]="user.role" name="role">
                    <mat-option *ngFor="let role of roles" [value]="role.value">
                        {{ role.viewValue }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div>
            <!-- email -->
            <mat-form-field fxFlex="100">
                <input matInput name="email" [(ngModel)]="user.email" placeholder="Email">
            </mat-form-field>
        </div>
    </div>
     
    <button mat-flat-button color="action" (click)="addUser()">Add User</button>
</div>